<template>
  <div>
    <v-row class="rounded no-gutters back-filtro pa-1" justify="center" align="center">
      <v-col cols="12" class="ma-0 pa-0 d-flex align-center">
        <span class="subtitle-1 font-weight-bold">{{title}}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">            
            <v-btn text icon color="primary" class="ml-auto" x-small @click="remove" v-on="on">
              <v-icon dark small>fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>Eliminar filtro</span>
        </v-tooltip>
      </v-col>  
      <v-col cols="12">
        <span class="text-primary">Seleccione Opción</span>
        <v-select
          :items="itemsSelect"
          item-text="titulo"
          item-value="valor"
          v-model="selectOpcion"
          hide-details
          outlined
          dense>
        </v-select>
      </v-col>
      <v-col v-if="selectOpcion!='between'" cols="12" class="py-0 ma-0">
        <span class="text-primary">Valor Filtrar</span>
        <v-text-field
          v-model="valorConsulta"
          dense
          outlined
          hide-details
          clearable>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import mixinGridComponenteFiltros from "@/mixins/GridComponenteFiltros.js"

  export default {
    name:"Texto",
    mixins: [mixinGridComponenteFiltros],
    data() {
      return {
        itemsSelect: [
          {titulo:'Contiene',valor: 'LIKE'},
          {titulo:'Igual',valor: '='},

        ],
        selectOpcion  : '=',
        valorConsulta : this.value,
      }
    },
    methods: {
      stringConsulta (){
        let sConsulta = ''
        let sValorMostrar = ''

        switch (this.selectOpcion) {
          case '': {
            sConsulta = ''
            break
          }
          case 'LIKE': {
            // envio ^ en remplazo de % por que si van numero el sistema lo interpreta como un char
            sConsulta = `LIKE '^${this.valorConsulta}^'`
            sValorMostrar = `Contiene: ${this.valorConsulta}`
            break
          }            
          case '=': {
            sConsulta = `= '${this.valorConsulta}'`
            sValorMostrar = this.valorConsulta
            break
          }
        }
        this.$emit("input",sConsulta)

        this.onAddInfoFiltro(this.campo , this.title, sValorMostrar)
      }
    },
    watch: {
      valorConsulta() {
        this.stringConsulta();
      },
      selectOpcion() {
        this.stringConsulta();
      },

    },
  }
</script>

<style scoped>

</style>